<template>
    <div>
        <banner heading="UPGRADES" description="UPGRADESDESCRIPTION" type="upgrade"></banner>
        <div class="container">
            <div class="row equal">
                <div class="col-sm-6 col-xs-12">
                    <paginate-links for="upgrades" :show-step-links="true" :limit="3"
                                    :classes="{
                                    'ul': ['pagination', 'btn-group', 'list-unstyled', 'pagination-md'],
                                    'li:not(.active)': ['btn', 'btn-secondary'],
                                    'li.active': ['btn', 'btn-primary'],
                                    '.next > a': 'next-link',
                                    '.prev > a': ['prev-link']
                                }"></paginate-links>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="input-group input-group-lg input-group-cstm">
                        <span class="input-group-prepend">
                            <label for="upgrade-filter" class="input-group-text"><i class="fa fa-filter"></i></label>
                        </span>
                        <select class="form-control custom-select" v-model="filterState" id="upgrade-filter" aria-label="Filter">
                            <option v-for="option in options" v-bind:value="option.value" v-bind:key="option.id">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="input-group-prepend">
                            <div class="input-group-text">
                                <label for="hide-applied">{{ 'HIDE_APPLIED' | translate }} &nbsp;</label>&nbsp;
                                <input v-model="hideApplied" id="hide-applied" type="checkbox">
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <hr>
            <paginate name="upgrades" tag="div" class="row" :list="upgrades" :per="12">
                <upgrade v-for="upgrade in paginated('upgrades')" :key="upgrade.id" :upgrade="upgrade"></upgrade>
            </paginate>
        </div>
    </div>
</template>

<script>
import upgradeComponent from './Upgrade.vue';
import banner from './Banner.vue';

export default {
    name:     'upgrade-list',
    computed: {
        hideApplied: {
            get() {
                return this.$store.state.game.hideAppliedUpgrades;
            },
            set(hide) {
                this.$store.commit('TOGGLE_HIDE_APPLIED_UPGRADES', hide);
            }
        },
        upgrades() {
            return this.$store.getters.allUpgrades.filter(
                upgrade => (upgrade.shop === this.filterState || this.filterState === '*')
                    && (!this.hideApplied || upgrade.isApplied === false)
            );
        }
    },
    created() {
        this.$store.dispatch('getAllUpgrades');
        this.$store.dispatch('getAllShops');
        this.$store.getters.allShops.forEach(shop => {
            this.options.push({ text: this.$t(shop.name), value: shop.id, id: shop.id });
        });
        this.options.push({ text: this.$t('GENERAL'), value: '*', id: 'gen' });
        this.options.push({ text: this.$t('allShops'), value: 'all', id: 'all' });
    },
    data() {
        return {
            paginate:    ['upgrades'],
            filterState: '*',
            options:     []
        };
    },
    components: {
        upgrade: upgradeComponent,
        banner
    }
};
</script>

<style scoped lang="less">
i.upgrade-font-icon, i.shop-font-icon, i.upgrade-font-icon {
    color: #b31243;
}
.col-sm-6.paginate-links {
    padding-left: 15px;
}
@media (min-width: 768px) {
    .pagination {
        margin-bottom: 0;
    }
}
</style>
